import script from "./AdminAddDevotional.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAddDevotional.vue?vue&type=script&setup=true&lang=js"

import "./AdminAddDevotional.vue?vue&type=style&index=0&id=4f57c7d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f57c7d8"]])

export default __exports__